<template>
  <div class="fixed inset-0 bg-gradient-to-br from-[#10103c] via-[#1a1a5c] to-[#2a2a7c] flex items-center justify-center z-50">
    <div class="text-center">
      <!-- Logo with pulse animation -->
      <div class="mb-6 animate-pulse">
        <div class="w-16 h-16 mx-auto bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm border border-white/20 shadow-lg">
          <svg class="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
          </svg>
        </div>
      </div>
      
      <!-- Loading text -->
      <p class="text-white text-lg font-medium mb-4 opacity-90">{{ loadingText }}</p>
      
      <!-- Animated dots -->
      <div class="flex justify-center space-x-1">
        <div class="w-2 h-2 bg-white rounded-full animate-bounce" style="animation-delay: 0ms"></div>
        <div class="w-2 h-2 bg-white rounded-full animate-bounce" style="animation-delay: 150ms"></div>
        <div class="w-2 h-2 bg-white rounded-full animate-bounce" style="animation-delay: 300ms"></div>
      </div>
      
      <!-- Optional progress bar -->
      <div v-if="showProgress" class="mt-6 w-64 mx-auto">
        <div class="bg-white/20 rounded-full h-2 overflow-hidden backdrop-blur-sm">
          <div 
            class="bg-gradient-to-r from-purple-400 to-blue-400 h-full rounded-full transition-all duration-300 ease-out"
            :style="{ width: progress + '%' }"
          ></div>
        </div>
        <p class="text-white/70 text-sm mt-2">{{ Math.round(progress) }}%</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    loadingText: {
      type: String,
      default: 'Loading...'
    },
    showProgress: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0 && value <= 100
    }
  }
};
</script>

<style scoped>
@keyframes bounce {
  0%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
}

.animate-bounce {
  animation: bounce 1s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
}

.animate-pulse {
  animation: pulse 2s ease-in-out infinite;
}

/* Ensure backdrop blur works properly */
.backdrop-blur-sm {
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
</style> 